export const formatNumber = (input) => {
    const output = +input
    return output.toLocaleString()
}